import DeviceManager from '../utils/device-manager';

const ServiceCarousel = {
    $swipers: [],
    swipers: {},

    init() {
        this.$swipers = document.querySelectorAll('.services-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index);
        });

    },

    initSwiper($swiper, name) {
        const $slides = $swiper.querySelectorAll('.swiper-slide');

        let args = {
            updateOnWindowResize: true,
            slidesPerView: 1,
            loop: false,
            allowTouchMove: true,
            threshold: 10,
            spaceBetween: 20,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: $slides.length > 1 ? {
                el: '.swiper-pagination',
                clickable: true,
            } : false,
            breakpoints: {},
        };

        args.breakpoints[DeviceManager.devices.sm] = {
            slidesPerView: 2,
            spaceBetween: 40,
        };

        args.breakpoints[DeviceManager.devices.md] = {
            slidesPerView: 3,
            spaceBetween: 40,
        };

        this.swipers[name] = new Swiper($swiper, args);
    }
}

export default ServiceCarousel;